import { candidateShortlist } from "./candidateShortlist";

const documents = {
  servicesProposal: "https://docs.google.com/document/d/1b__Ja0LTl82KdSWV7HhIlhmcxOa6kiIXaubZRGjHoJc/edit?usp=sharing",
  servicesContract: "https://docs.google.com/document/d/1b__Ja0LTl82KdSWV7HhIlhmcxOa6kiIXaubZRGjHoJc/edit?usp=sharing",
  confidentialAgreement: "https://docs.google.com/document/d/1b__Ja0LTl82KdSWV7HhIlhmcxOa6kiIXaubZRGjHoJc/edit?usp=sharing",
  invoices: [
    {
      id: 1,
      name: "Retainer Payment",
      url: "https://docs.google.com/document/d/1b__Ja0LTl82KdSWV7HhIlhmcxOa6kiIXaubZRGjHoJc/edit?usp=sharing"
    },
    {
      id: 2,
      name: "Invoice #2 - Shortlist Delivery Payment",
      url: "https://docs.google.com/document/d/1b__Ja0LTl82KdSWV7HhIlhmcxOa6kiIXaubZRGjHoJc/edit?usp=sharing"
    },
    {
      id: 3,
      name: "Invoice #3 - Placement Delivery Payment",
      url: "https://docs.google.com/document/d/1b__Ja0LTl82KdSWV7HhIlhmcxOa6kiIXaubZRGjHoJc/edit?usp=sharing"
    }
  ],
}

const TEST_LOOM_VIDEO = "https://www.loom.com/embed/221f217704be4b668928c1a4cacb2f0e"

const videos = {
  getStartedVideo: {
    title: "Onboarding Video",
    url: TEST_LOOM_VIDEO
  },
  jobPostingVideo: {
    title: "About the Job Posting",
    url: TEST_LOOM_VIDEO
  },
  shortlistVideo: {
    title: "Shortlist Candidates Explained",
    url: TEST_LOOM_VIDEO
  },
  orderStatusVideo: {
    title: "Order Status Explained",
    url: TEST_LOOM_VIDEO
  },
}

const jobPosting = {
  jobTitle: "CA Technical Specialist",
  jobLocation: "Vancouver, Canada",
  jobTeam: "Hardware Team",
  applyNowURL: "https://florianlaurentgroup.com/careers",
  datePosted: "2021-08-01",
  jobSummary: "After customers purchase our products, you’re the one who helps them get more out of their new Apple technology. Your day in the Apple Store is filled with a range of focused support and service tasks. Whether you’re helping customers get started with the Mac or finding answers to their questions about other Apple devices, you’re ready to share knowledge and provide exceptional assistance. You gain satisfaction from bringing resolution and insight to each customer, elevating his or her relationship with Apple to the next level. Both full-time and part-time jobs are available.",
  keyQualifications: [
    "Ability to assess customers’ support needs when they arrive, then provide solutions or refer them to other team members",
    "Flexibility to regularly rotate through different technical specialties and skill sets",
    "Ability to thrive on change as products evolve",
    "Ability to take initiative and proactively identify opportunities to improve the customer experience",
    "Ability to build strong relationships with customers and teammates",
    "Ability to work both independently and as part of a team",
    "Ability to multitask, prioritize, and manage time effectively",
    "Ability to communicate clearly and effectively",
    "Ability to work a flexible schedule that includes evenings, holidays, and weekends",
  ],
  description: [
    "As a member of the Apple Store team, you’re the face of Apple, delivering the very best in customer service. You’re also the person who keeps the store running smoothly, from taking inventory to making sure the store looks its best. You’re proud to represent Apple, and you get great satisfaction from helping customers develop lifelong relationships with Apple."
  ],
  additionalRequirements: [
    "High school or equivalent (Required)",
    "1 year of customer service experience (Preferred)",
  ],
  jumbotronSection: {
    tagline: "Join a team and inspire the work.",
    description: "Discover how you can make an impact: see our areas of work, worldwide locations and opportunities for students.",
  },
  aboutSection: {
    description: [
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quas neque sed, accusantium cupiditate aperiam ipsa facere ratione inventore deserunt beatae nostrum dignissimos sit possimus ipsum minima voluptates. Dolorem, eveniet harum. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quas neque sed, accusantium cupiditate aperiam ipsa facere ratione inventore deserunt beatae nostrum dignissimos sit possimus ipsum minima voluptates. Dolorem, eveniet harum."
    ],
  },
  teamsSection: {
    description: "",
    teams: [
      {
        id: 1,
        teamName: "Hardware Team",
        teamDescription: "Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
      },
      {
        id: 2,
        teamName: "Software Team",
        teamDescription: "Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
      },
      {
        id: 3,
        teamName: "Optics Team",
        teamDescription: "Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
      }
    ]
  },
  locationsSection: [
    "Vancouver",
    "Toronto",
    "Montreal",
  ],
  featuredEmployeesSection: [
    {
      firstName: "John",
      prompt: "My favorite memory",
      quote: "Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order."
    },
    {
      firstName: "John",
      prompt: "My favorite memory",
      quote: "Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order."
    },
  ],
  benefitsSection: [
    {
      benefitName: "Health Insurance",
      details: "Coverage for medical expenses, including doctor visits, hospitalizations, and prescription drugs."
    },
    {
      benefitName: "Health Insurance",
      details: "Coverage for medical expenses, including doctor visits, hospitalizations, and prescription drugs."
    },
    {
      benefitName: "Health Insurance",
      details: "Coverage for medical expenses, including doctor visits, hospitalizations, and prescription drugs."
    }
  ],
  companyValuesSection: {
    tagline: "",
    description: "",
    values: [
      {
        valueName: "Integrity",
        details: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quae."
      },
      {
        valueName: "Integrity",
        details: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quae."
      },
      {
        valueName: "Integrity",
        details: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quae."
      },
      {
        valueName: "Integrity",
        details: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quae."
      },
      {
        valueName: "Integrity",
        details: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quae."
      },
      {
        valueName: "Integrity",
        details: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quae."
      }
    ]
  },
}

const recruiterRepresentatives = [
  {
    firstName: "John",
    lastName: "Doe",
    type: "Primary",
    role: "Senior Recruiter",
    email: "johndoe@company.com",
    phone: "(123) 456-7890",
    facebookURL: "https://www.facebook.com/johndoe",
    instagramURL: "https://www.instagram.com/johndoe",
    githubURL: "https://github.com/johndoe",
    linkedinURL: "https://www.linkedin.com/in/johndoe",
    twitterURL: "https://twitter.com/johndoe",
    youtubeURL: "https://www.youtube.com/johndoe",
    contactFile: "https://florianlaurentgroup.com/contact/johndoe_contact.pdf"
  },
  {
    firstName: "Jane",
    lastName: "Smith",
    type: "Secondary",
    role: "Recruiting Coordinator",
    email: "janesmith@company.com",
    phone: "(123) 456-7890",
    facebookURL: "https://www.facebook.com/janesmith",
    instagramURL: "https://www.instagram.com/janesmith",
    githubURL: "https://github.com/janesmith",
    linkedinURL: "https://www.linkedin.com/in/janesmith",
    twitterURL: "https://twitter.com/janesmith",
    youtubeURL: "https://www.youtube.com/janesmith",
    contactFile: "https://florianlaurentgroup.com/contact/janesmith_contact.pdf"
  }
];

const companyInformation = {
  companyName: "Amazon",
  companyURL: "https://www.amazon.ca",
  location: "Seattle, Washington",
}

export const order = {
  documents,
  videos,
  jobPosting,
  recruiterRepresentatives,
  companyInformation,
  candidateShortlist,
}